import { g as getViewportWidth } from './get-viewport-width-1dbd5917.js';
import { h as hasRTLContext } from './has-rtl-context-8d0c1a2f.js';

const MIN_OFFSET_TO_VIEWPORT_EDGES_PX = 8;
const ARROW_SIZE_PX = 8;
const MAGIC_OFFSET_NUMBER = 16; // TODO: Find out why this is needed. Replace, if possible
function transformEl(el, x = '0', y = '0', z = '0') {
  el.style.transform = `translate3d(${x}, ${y}, ${z})`;
  el.style.webkitTransform = `translate3d(${x}, ${y}, ${z})`;
}
/**
 * Vertically center overlayEl relative to overlayHost
 */
const centerVerticallyToHost = (overlayEl, overlayRect, overlayHostRect) => {
  const verticalAdjustment = overlayHostRect.height / 2 - overlayRect.height / 2;
  transformEl(overlayEl, '0', `${verticalAdjustment}px`, '0');
};
/**
 * Apply horizontal transform to overlayEl
 */
const adjustVerticalPosition = (correctedhorizontalAdjustment, overlayEl) => {
  transformEl(overlayEl, `${correctedhorizontalAdjustment}px`);
};
const flipHorizontallyIfOutsideViewport = (overlayEl, overlayHostEl, overlayRect, position, flipClass, contextEl = window.document.documentElement) => {
  const { x, width } = contextEl.getBoundingClientRect();
  const SAFE_LEFT = x + MIN_OFFSET_TO_VIEWPORT_EDGES_PX;
  const SAFE_RIGHT = x + width - MIN_OFFSET_TO_VIEWPORT_EDGES_PX;
  const isRTL = hasRTLContext(overlayEl);
  const positionToCheckForRightOverflow = isRTL ? 'start' : 'end';
  const positionToCheckForLeftOverflow = isRTL ? 'end' : 'start';
  const hostRect = overlayHostEl.getBoundingClientRect();
  const spaceLeftOfHost = hostRect.left - SAFE_LEFT - ARROW_SIZE_PX;
  const spaceRightOfHost = SAFE_RIGHT - hostRect.right - ARROW_SIZE_PX;
  const spaceOnRequestedSideAfterTooltipHasBeenPlaced = (position === positionToCheckForLeftOverflow && spaceLeftOfHost - overlayRect.width) || (position === positionToCheckForRightOverflow && spaceRightOfHost - overlayRect.width);
  const spaceOnFlipSideAfterTooltipHasBeenPlaced = (position === positionToCheckForLeftOverflow && spaceRightOfHost - overlayRect.width) || (position === positionToCheckForRightOverflow && spaceLeftOfHost - overlayRect.width);
  if (spaceOnRequestedSideAfterTooltipHasBeenPlaced < 0) {
    if (spaceOnFlipSideAfterTooltipHasBeenPlaced < 0) {
      // tooltip neither fits left or right. pick side with most space and apply max-width
      if (spaceOnFlipSideAfterTooltipHasBeenPlaced < spaceOnRequestedSideAfterTooltipHasBeenPlaced) {
        const maxWidth = position === positionToCheckForLeftOverflow ? spaceLeftOfHost : spaceRightOfHost;
        overlayEl.style.maxWidth = `${maxWidth - MIN_OFFSET_TO_VIEWPORT_EDGES_PX - ARROW_SIZE_PX - MAGIC_OFFSET_NUMBER}px`;
      }
      else {
        const maxWidth = position === positionToCheckForLeftOverflow ? spaceRightOfHost : spaceLeftOfHost;
        overlayEl.style.maxWidth = `${maxWidth - MIN_OFFSET_TO_VIEWPORT_EDGES_PX - ARROW_SIZE_PX - MAGIC_OFFSET_NUMBER}px`;
        overlayHostEl.classList.add(flipClass);
      }
    }
    else {
      // tooltip fits on flip side
      overlayHostEl.classList.add(flipClass);
    }
  }
};
// flips popover to other side, if it doesn't fit into viewport
const flipVerticallyIfOutsideViewport = (overlayHostEl, overlayRect, position, flipClass, contextEl = window.document.documentElement) => {
  const { top, height } = contextEl.getBoundingClientRect();
  const SAFE_TOP = top + MIN_OFFSET_TO_VIEWPORT_EDGES_PX;
  const SAFE_BOTTOM = height - MIN_OFFSET_TO_VIEWPORT_EDGES_PX;
  if ((position === 'top' && overlayRect.top < SAFE_TOP) || (position === 'bottom' && overlayRect.bottom > SAFE_BOTTOM)) {
    overlayHostEl.classList.add(flipClass);
  }
};
const getLayoutVariables = (overlayRect, overlayHostRect) => {
  const viewportWidth = getViewportWidth();
  const halfParentElWidth = overlayHostRect.width / 2;
  const halfPopoverElWidth = overlayRect.width / 2;
  const adjustmentToCenterX = halfParentElWidth - halfPopoverElWidth;
  const parentCenterX = overlayHostRect.left + halfParentElWidth;
  const leftAfterCentering = parentCenterX - halfPopoverElWidth;
  const rightAfterCentering = parentCenterX + halfPopoverElWidth;
  return { viewportWidth, adjustmentToCenterX, leftAfterCentering, rightAfterCentering };
};
/**
 * Get adjustment to position overlay within grid boundaries on the left
 */
const getWithinGridAdjustment = (overlayRect, overlayHostRect, gridOuterMarginPercentage) => {
  const { viewportWidth, adjustmentToCenterX, leftAfterCentering } = getLayoutVariables(overlayRect, overlayHostRect);
  const positionLeft = viewportWidth * gridOuterMarginPercentage;
  return adjustmentToCenterX + positionLeft - leftAfterCentering;
};
/**
 * Get adjustment to position overlay within viewport
 */
const getWithinViewportAdjustment = (overlayRect, overlayHostRect) => {
  const { viewportWidth, adjustmentToCenterX, leftAfterCentering, rightAfterCentering } = getLayoutVariables(overlayRect, overlayHostRect);
  const SAFE_LEFT = MIN_OFFSET_TO_VIEWPORT_EDGES_PX;
  const SAFE_RIGHT = viewportWidth - MIN_OFFSET_TO_VIEWPORT_EDGES_PX;
  // 1.
  if (leftAfterCentering < SAFE_LEFT) {
    const delta = Math.abs(leftAfterCentering) + SAFE_LEFT;
    return adjustmentToCenterX + delta;
  }
  else if (rightAfterCentering > SAFE_RIGHT) {
    const delta = rightAfterCentering - SAFE_RIGHT;
    return adjustmentToCenterX - delta;
  }
  return adjustmentToCenterX;
};

export { adjustVerticalPosition as a, getWithinViewportAdjustment as b, flipHorizontallyIfOutsideViewport as c, centerVerticallyToHost as d, flipVerticallyIfOutsideViewport as f, getWithinGridAdjustment as g };
